module.exports = __webpack_public_path__ + "static/img/tkzz.5e33feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tkzz.jpg
// module id = 55XW
// module chunks = 0